import {AfterViewInit, Component, Inject, OnInit, ViewChild} from '@angular/core';
import {AcDialog, DIALOG_CONFIG} from 'ac-infra';
import * as _ from 'lodash';
import {AbstractControl, FormControl, NgForm, Validators} from '@angular/forms';
import {SipHeadersService} from '../../../../services/common/sip-headers/sip-headers.service';

class ValidationErrors {
}

@AcDialog({
  id: 'sipConditionGroups',
  height: 540,
  width: 1300
})
@Component({
  selector: 'sip-condition-groups-dialog',
  templateUrl: './sip-condition-groups-dialog.component.html',
  styleUrls: ['./sip-condition-groups-dialog.component.scss']
})
export class SipConditionGroupsDialogComponent implements OnInit, AfterViewInit {

  @ViewChild('sipConditionForm') sipConditionForm: NgForm;

  data: any;

  headerStructure;
  headerOperators;
  subjectSuggestions;
  filteredOperatorOptions;
  prefixGroupsOptions;
  operatorOptions;
  dialogData;

  logicalOperatorOptions = [
    { value: 'or', text: 'Or' },
    { value: 'and', text: 'And' }
  ];

  subjectControl: FormControl;

  constructor(@Inject(DIALOG_CONFIG) private dialogConfig,
              private sipHeadersService: SipHeadersService) {
    this.dialogData = dialogConfig.dialogData;
    this.headerStructure = dialogConfig.dialogData.headerStructure;
    this.headerOperators = dialogConfig.dialogData.headerOperators;
    this.operatorOptions = dialogConfig.dialogData.operatorOptions;
    this.prefixGroupsOptions = dialogConfig.dialogData.prefixGroupsOptions;
    this.data = dialogConfig.dialogData.data;

    this.data.conditions.forEach(condition => {
      this.updateSubjectSuggestions(condition.subject, condition);
    });

    this.initializeData();

    this.dialogConfig.preSubmit = () => {
      this.dialogData.conditionGroup = _.cloneDeep(this.data);
      this.dialogData.conditionGroup.conditions.map((condition, i, conditions) => {
        if (condition.operator === 'regex') {
          condition.values = [`'${condition.regex}'`];
          delete condition.regex;
        } else if (condition.operator === 'exist' || condition.operator === 'notExist') {
          condition.values = [];
        }

        if (conditions.length - 1 === i) {
          delete condition.logicalOperator;
        }
        condition.priority = ++i;

        delete condition.subjectControl;
        delete condition.operatorOptions;
      });
    };
  }

  ngOnInit(): void {
    this.isConditionGroupValid();
  }

  addCondition(): void {
    this.data.conditions.push({
      values: [],
      logicalOperator: 'and',
      subjectControl: new FormControl('', [
        Validators.required, this.subjectValidator()
      ])
    });
  }

  moveRuleUp(index): void {
    this.swapConditionRules(index, --index);
  }

  moveRuleDown(index): void {
    this.swapConditionRules(index, ++index);
  }

  removeRuleDown(index): void {
    this.data.conditions.splice(index, 1);
  }

  private swapConditionRules(index1, index2): void {
    const tempRule = this.data.conditions[index1];

    this.data.conditions[index1] = this.data.conditions[index2];
    this.data.conditions[index2] = tempRule;
  }

  updateSubjectSuggestions($event: any = '', condition = null): void {
    this.subjectSuggestions = this.sipHeadersService.generateSubjectSuggestions($event);

    if (condition) {
      condition.operatorOptions = this.sipHeadersService.generateOperatorsForHeader($event);

      if (_.isNil(condition.operatorOptions) || (condition.operatorOptions && !_.isNil(condition.operator) &&
        !condition.operatorOptions.find(item => item.value === condition.operator))) {
        condition.operator = '';
      }
    }
  }

  trackByIdx(index: number): any {
    return index;
  }

  onAddValueApply(data): void {
    data.group.values = [...data.group.values, data.customValue];
    this.valuesFocusout(data.group);
    this.isConditionGroupValid();
  }

  isConditionGroupValid(): void {
    let isDialogValid = false;

    if (_.isNil(this.data.name)) {
      isDialogValid = true;
    }

    this.data.conditions.forEach(condition => {
      if (!this.sipHeadersService.generateOperatorsForHeader(condition.subject)) {
        isDialogValid = true;
      }

      if (_.isEmpty(condition.operator)) {
        isDialogValid = true;
      }

      if (!['exist', 'notExist', 'regex', 'belong'].includes(condition.operator)
        && _.isEmpty(condition.values)) {
        isDialogValid = true;
      } else if ((condition.operator === 'regex') && _.isEmpty(condition.regex)) {
        isDialogValid = true;
      } else if ((condition.operator === 'belong') && _.isEmpty(condition.prefixGroups)) {
        isDialogValid = true;
      }
    });

    this.dialogConfig.submitButtonDisabled = isDialogValid;
  }

  ngAfterViewInit(): void {
    this.sipConditionForm.form.statusChanges.subscribe(() => {
      this.isConditionGroupValid();
    });
  }

  operatorFocusout(condition): void {
    condition.operatorError = _.isNil(condition.operator) ? 'Operator is required' : null;
  }

  valuesFocusout(condition): void {
    let isInvalid = false;

    if (condition.operator !== 'belong') {
      condition.prefixGroups = [];
      if (_.isEmpty(condition.values)) {
        isInvalid = true;
      }
    } else {
      condition.values = [];
      if (_.isEmpty(condition.prefixGroups)) {
        isInvalid = true;
      }
    }
    condition.valuesError = isInvalid ? 'Values is required' : null;
  }

  subjectValidator(): any {
    return (control: AbstractControl): ValidationErrors | null => {
      return _.isEmpty(this.sipHeadersService.generateOperatorsForHeader(control.value)) ? { error: 'Invalid Subject' } : null;
    };
  }

  private initializeData(): void {
    this.data.conditions.map(condition => {
      if (condition.operator === 'regex') {
        condition.regex = condition.values[0].slice(1, -1);
        condition.values = [];
      }

      if (_.isNil(condition.logicalOperator)) {
        condition.logicalOperator = 'and';
      }

      condition.subjectControl = new FormControl('', [
        Validators.required, this.subjectValidator()
      ]);
    });
  }
}
